import * as React from 'react';
export const supportSvg = React.forwardRef(function supportSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.472 6.472 0 0 1-1.404 4.035l-1.07-1.07a5.032 5.032 0 0 1-1.06 1.061l1.07 1.07A6.472 6.472 0 0 1 8 14.5a6.472 6.472 0 0 1-4.035-1.404l1.07-1.07A4.98 4.98 0 0 0 8 13a5 5 0 0 0 4.026-7.965l1.07-1.07A6.472 6.472 0 0 1 14.5 8Zm-2.464-5.096A6.472 6.472 0 0 0 8 1.5a6.472 6.472 0 0 0-4.035 1.404l1.07 1.07A4.978 4.978 0 0 1 8 3c1.11 0 2.136.362 2.966.974l1.07-1.07Zm-8.062 8.062A4.977 4.977 0 0 1 3 8c0-1.11.362-2.136.974-2.965l-1.07-1.07A6.472 6.472 0 0 0 1.5 8c0 1.525.525 2.927 1.404 4.036l1.07-1.07ZM11.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z',
    }),
  );
});
supportSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var support = {
  category: 'icon',
  colorable: true,
  name: 'support',
  svg: supportSvg,
};
